<template>
<header class="ghost-navbar">
    <nav>
        <div @click="goBack" class="brand" alt="Kolkin">
            <img src="@/assets/img/icon_256x256.png" />
        </div>

        <!-- <div @click="goBack" class="flare">
            <span>SOS<small>&reg;</small>List</span>
        </div> -->

        <div class="links">
            <router-link class="print-hide" :to="{name: 'kolkin'}">
                SOS
            </router-link>
            <!-- <router-link class="lg-only print-hide" :to="{name: 'blog', params: {category: 'All'}}" :class="{active: $route.name == 'blog'}">
                Blog
            </router-link>
            <router-link class="lg-only print-hide" :to="{name: 'help', params: {category: 'All'}}" :class="{active: $route.name == 'help'}">
                Docs
            </router-link> -->
            <router-link class="print-hide" :to="{name: 'pricing'}" :class="{active: $route.name == 'pricing'}">
                Pricing
            </router-link>
            <router-link class="print-hide" :to="{name: 'contact'}" :class="{active: $route.name == 'contact'}">
                Contact Us
            </router-link>
            <router-link :to="{name: 'licenses'}" class="print-hide" :class="{active: $route.name == 'licenses'}">
                Account
            </router-link>
        </div>

        <div class="right">
            <!-- <a @click.stop.prevent="toggleSearch" class="print-hide" title="Search">
                <i class="icon icon-search"></i>
            </a> -->
            <a v-if="user.kolkinid" @click="pushToSignout" class="print-hide">
                Sign Out
            </a>
        </div>
    </nav>
</header>
</template>

<script>
import {
    mapGetters
} from "vuex";
import Popper from "@/../submodules/vue-base/components/Popper";
export default {
    name: "GhostNavbar",

    components: {
        Popper
    },

    data() {
        return {
            expandHeight: "200px",
            activeExpand: "",
            openExpand: false,
            openingExpand: false,
            openingTransition: false,
            haveExpand: true,
        };
    },

    methods: {

        goBack() {
            window.location = '/';
        },

        pushToAccount() {
            this.$router.push({name: "licenses"});
        },

        pushToSignout() {
            this.$store.dispatch("signout").then(function () {
                window.location = '/';
            })
        },
        isActive(expandName) {
            return this.activeExpand == expandName;
        },

        dropdownClick() {
            this.$refs.dropdown.toggle();
        },

        showExpand(menuName) {
            if (this.openExpand) {
                this.activeExpand = menuName;
                this.expandHeight = this.getExpandHeight(menuName);
            } else {
                this.openingExpand = true;
                this.openingTransition = true;
                this.activeExpand = menuName;

                setTimeout(() => {
                    if (this.activeExpand == menuName && this.openingExpand) {
                        this.openExpand = true;
                        this.expandHeight = this.getExpandHeight(menuName);
                        this.openingExpand = false;
                    }
                }, 240);

                setTimeout(() => {
                    this.openingTransition = false;
                }, 1000);
            }
        },

        getExpandHeight(ref) {
            var targetExpand = this.$refs[ref];
            return targetExpand.$el.offsetHeight + "px";
        },

        toggleSearch() {
            this.$store.dispatch("toggleSearchOpen");
        },

        closeSearch() {
            if (this.searchOpen) {
                this.toggleSearch();
            }
        },

        clearExpand() {
            this.openExpand = false;
            this.openingExpand = false;
            this.activeExpand = "";
            this.openingTransition = false;
        },
    },

    watch: {
        $route(to, from) {
            this.haveExpand = false;
            this.$nextTick(() => {
                this.haveExpand = true;
            })
            this.clearExpand();
        },
    },

    computed: {
        ...mapGetters(["user", "licenses", "searchOpen"]),
    },
};
</script>
